<template>
	<div id="singlePage" class="container">
		<div class="row">
			<div id="left" class="col-md-3 col-sm-3 hidden-xs">
				<left-nav
                    @on-click="clickNav"
					:leftMenuList="leftMenuList"
					:nowId="$route.params.id">
				</left-nav>
				<!-- <ul class="left-container wow bounceInLeft" >
                    <p>软件产品</p>
                    <li v-for="(item,index) in softwareList" :key="index">
                        <router-link :to=item.path>{{item.name}}</router-link>
                    </li>
                </ul> -->
			</div>
			<div id="right" class="col-md-9 col-sm-9 col-xs-12  wow">
				<div class="title">
					{{articleInfo.title}}
					<div class="underline"><!-- 下划线样式，勿删 --></div>
				</div>
				<div style="margin-top: 10px;" v-if="articleInfo.fileList.length > 0" v-for="(item,index) in articleInfo.fileList" :key="index + 'key'">
					<span>{{item.fileName}}</span><a :href="item.fileUrl" target="_blank" style="color: #01aaed;text-decoration: none;">{{ $t("message.i18n_24") }}</a>
				</div>
				<div>
					<iframe
						id="myiframe"
						:srcdoc="articleInfo.content"
						width='100%'
						:frameborder="0"
						scrolling="yes"
						height="this.height=100">
					</iframe>
					<!-- <span class="vhtml" v-html="articleInfo.content"></span> -->
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		GetSinglePage
	} from '../api/api.js'
	import {
		WOW
	} from "wowjs";
	import LeftNav from '../components/leftNav.vue'
	export default {
		name: 'singlepage',
		components: {
			LeftNav
		},
		data() {
			return {
                isApple:true,
				articleInfo: [],
				leftMenuList: [],
			}
		},
		created() {
			// console.log('---')
            this.appDown();
			if(this.$route.params.id) {
				this.getSinglePage(this.$route.params.id)
			}
			var wow = new WOW();
			wow.init();
		},
		mounted() {
			// this.changeFrameHeight()
		},
		watch: {
			'$route'(newVal) {
				// 监听相同路由下参数变化的时候，从而实现异步刷新
				var wow = new WOW();
				wow.init();
				this.GoTop()
				this.getSinglePage(newVal.params.id)
			},
			leftMenuList(newVal) {
				let leftMenuList = {}

				//console.log(leftMenuList,'leftMenuList11')
				return newVal
			}
		},
		methods: {
            appDown() {
                var u = navigator.userAgent;
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                if(isiOS){
                    this.isApple = true
                }else if(isAndroid){
                    this.isApple = false
                }
            },
            clickNav(e) {
                // console.log("clickNav", e)
                this.articleInfo = {title: e}
            },
			changeFrameHeight() {
				var ifm = document.getElementById("myiframe");
				ifm.height = 0

                // 设置样式
                const ifmDocument = ifm.contentDocument;
                const link1 = ifmDocument.createElement('link')
                link1.href = "../../static/tinymce/oxide/content.min.css"
                link1.type = "text/css"
                link1.rel = "stylesheet"
                ifmDocument.head.append(link1);
                const link2 = ifmDocument.createElement('link')
                link2.href = "../../static/tinymce/default/content.min.css"
                link2.type = "text/css"
                link2.rel = "stylesheet"
                ifmDocument.head.append(link2);
                ifmDocument.body.className = "mce-content-body"

				setTimeout(() => {
					var dHeight = ifm.contentWindow.document.documentElement.scrollHeight + 20
					ifm.height = dHeight
				}, 400)
			},
			// 回到顶部
			GoTop() {
			  (function smoothscroll() {
			    var currentScroll =
			      document.documentElement.scrollTop || document.body.scrollTop;
			    if (currentScroll > 0) {
			      window.requestAnimationFrame(smoothscroll);
			      window.scrollTo(0, currentScroll - currentScroll / 10);
			    }
			  })();
			},
			// 获取单页菜单数据
			getSinglePage(menuId) {
				GetSinglePage(menuId).then( res => {
					if(res && res.errorCode == 0) {
						let data = {}
						if(this.$store.state.languageVuex == 'en') {
							let objEnglish = JSON.parse(JSON.stringify(res.data).replace(/titleEnglish/g,"enName"))
							let obj = JSON.parse(JSON.stringify(objEnglish).replace(/title/g,"zh-CN"))
							let title = JSON.parse(JSON.stringify(obj).replace(/enName/g,"title"))
							data = title
						} else {
							data = res.data
						}
                        this.leftMenuList = data.leftMenuList

                        var ifm = document.getElementById("myiframe");
                        ifm.height = 0
                        if (data.articleInfo.title) {
                            data.articleInfo.content = '<div>' + data.articleInfo.content + "</div>"
                            this.articleInfo = data.articleInfo
                            if (this.isApple) {
                                ifm.contentWindow.document.write(data.articleInfo.content)
                            }
                        }
						setTimeout(() => {
							this.changeFrameHeight()
						}, 50)
					}
				})
			}
		}
	}
</script>
<style scoped>
	.vhtml  >>> img {
		display: block;
		height: auto;
		max-width: 100%;
		margin: 0 auto;
	}

	.vhtml  >>> table{
		width: 100%;
	}
	#singlePage {
		min-height: 400px;
	}
	#left {
		margin: 30px 0;
	}

	.left-container {
		width: 60%;
		margin: 0 auto;
		border: 1px solid #474747;
		border-radius: 5px;
	}

	.left-container>p {
		text-align: center;
		line-height: 45px;
		padding: 0;
		margin: 0;
		background: #474747;
		color: #fff;
		font-size: 18px;
		font-weight: bold;
	}

	.left-container>li {
		text-align: center;
		height: 38px;
		line-height: 38px;
		margin: 0;
		border-top: 1px solid #474747;
	}

	.left-container>li>a {
		text-decoration: none;
	}

	.left-container>li:hover {
		background: #928989;
	}

	#right {
		margin: 30px 0;
	}

	#right .title {
		font-size: 22px;
		font-weight: normal;
		color: #545454;
		line-height: 50px;
		border-bottom: 1px solid #ebebeb;
		position: relative;
	}

	#right .title .underline {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 86px;
		border-bottom: 1px solid #C71625;
	}

	@media screen and (max-width: 768px) {
		#right {
			/* padding: 15px; */
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/singlepage.vue